
/**
 * Maps specific arXiv categories to broader parent categories
 * for better visualization in charts and analytics
 */

// Detailed arXiv category names for display
export const ARXIV_CATEGORY_NAMES: Record<string, string> = {
  "cs.AI": "Artificial Intelligence",
  "cs.AR": "Hardware Architecture",
  "cs.CC": "Computational Complexity",
  "cs.CE": "Computational Engineering, Finance, and Science",
  "cs.CG": "Computational Geometry",
  "cs.CL": "Computation and Language",
  "cs.CR": "Cryptography and Security",
  "cs.CV": "Computer Vision and Pattern Recognition",
  "cs.CY": "Computers and Society",
  "cs.DB": "Databases",
  "cs.DC": "Distributed, Parallel, and Cluster Computing",
  "cs.DL": "Digital Libraries",
  "cs.DM": "Discrete Mathematics",
  "cs.DS": "Data Structures and Algorithms",
  "cs.ET": "Emerging Technologies",
  "cs.FL": "Formal Languages and Automata Theory",
  "cs.GL": "General Literature",
  "cs.GR": "Graphics",
  "cs.GT": "Computer Science and Game Theory",
  "cs.HC": "Human-Computer Interaction",
  "cs.IR": "Information Retrieval",
  "cs.IT": "Information Theory",
  "cs.LG": "Machine Learning",
  "cs.LO": "Logic in Computer Science",
  "cs.MA": "Multiagent Systems",
  "cs.MM": "Multimedia",
  "cs.MS": "Mathematical Software",
  "cs.NA": "Numerical Analysis",
  "cs.NE": "Neural and Evolutionary Computing",
  "cs.NI": "Networking and Internet Architecture",
  "cs.OH": "Other Computer Science",
  "cs.OS": "Operating Systems",
  "cs.PF": "Performance",
  "cs.PL": "Programming Languages",
  "cs.RO": "Robotics",
  "cs.SC": "Symbolic Computation",
  "cs.SD": "Sound",
  "cs.SE": "Software Engineering",
  "cs.SI": "Social and Information Networks",
  "cs.SY": "Systems and Control",

  "econ.EM": "Econometrics",
  "econ.GN": "General Economics",
  "econ.TH": "Theoretical Economics",

  "eess.AS": "Audio and Speech Processing",
  "eess.IV": "Image and Video Processing",
  "eess.SP": "Signal Processing",
  "eess.SY": "Systems and Control",

  "math.AC": "Commutative Algebra",
  "math.AG": "Algebraic Geometry",
  "math.AP": "Analysis of PDEs",
  "math.AT": "Algebraic Topology",
  "math.CA": "Classical Analysis and ODEs",
  "math.CO": "Combinatorics",
  "math.CT": "Category Theory",
  "math.CV": "Complex Variables",
  "math.DG": "Differential Geometry",
  "math.DS": "Dynamical Systems",
  "math.FA": "Functional Analysis",
  "math.GM": "General Mathematics",
  "math.GN": "General Topology",
  "math.GR": "Group Theory",
  "math.GT": "Geometric Topology",
  "math.HO": "History and Overview",
  "math.IT": "Information Theory",
  "math.KT": "K-Theory and Homology",
  "math.LO": "Logic",
  "math.MG": "Metric Geometry",
  "math.MP": "Mathematical Physics",
  "math.NA": "Numerical Analysis",
  "math.NT": "Number Theory",
  "math.OA": "Operator Algebras",
  "math.OC": "Optimization and Control",
  "math.PR": "Probability",
  "math.QA": "Quantum Algebra",
  "math.RA": "Rings and Algebras",
  "math.RT": "Representation Theory",
  "math.SG": "Symplectic Geometry",
  "math.SP": "Spectral Theory",
  "math.ST": "Statistics Theory",

  "astro-ph.CO": "Cosmology and Nongalactic Astrophysics",
  "astro-ph.EP": "Earth and Planetary Astrophysics",
  "astro-ph.GA": "Astrophysics of Galaxies",
  "astro-ph.HE": "High Energy Astrophysical Phenomena",
  "astro-ph.IM": "Instrumentation and Methods for Astrophysics",
  "astro-ph.SR": "Solar and Stellar Astrophysics",

  "cond-mat.dis-nn": "Disordered Systems and Neural Networks",
  "cond-mat.mes-hall": "Mesoscale and Nanoscale Physics",
  "cond-mat.mtrl-sci": "Materials Science",
  "cond-mat.other": "Other Condensed Matter",
  "cond-mat.quant-gas": "Quantum Gases",
  "cond-mat.soft": "Soft Condensed Matter",
  "cond-mat.stat-mech": "Statistical Mechanics",
  "cond-mat.str-el": "Strongly Correlated Electrons",
  "cond-mat.supr-con": "Superconductivity",

  "gr-qc": "General Relativity and Quantum Cosmology",

  "hep-ex": "High Energy Physics - Experiment",
  "hep-lat": "High Energy Physics - Lattice",
  "hep-ph": "High Energy Physics - Phenomenology",
  "hep-th": "High Energy Physics - Theory",

  "math-ph": "Mathematical Physics",

  "nlin.AO": "Adaptation and Self-Organizing Systems",
  "nlin.CD": "Chaotic Dynamics",
  "nlin.CG": "Cellular Automata and Lattice Gases",
  "nlin.PS": "Pattern Formation and Solitons",
  "nlin.SI": "Exactly Solvable and Integrable Systems",

  "nucl-ex": "Nuclear Experiment",
  "nucl-th": "Nuclear Theory",

  "physics.acc-ph": "Accelerator Physics",
  "physics.ao-ph": "Atmospheric and Oceanic Physics",
  "physics.app-ph": "Applied Physics",
  "physics.atm-clus": "Atomic and Molecular Clusters",
  "physics.atom-ph": "Atomic Physics",
  "physics.bio-ph": "Biological Physics",
  "physics.chem-ph": "Chemical Physics",
  "physics.class-ph": "Classical Physics",
  "physics.comp-ph": "Computational Physics",
  "physics.data-an": "Data Analysis, Statistics and Probability",
  "physics.ed-ph": "Physics Education",
  "physics.flu-dyn": "Fluid Dynamics",
  "physics.gen-ph": "General Physics",
  "physics.geo-ph": "Geophysics",
  "physics.hist-ph": "History and Philosophy of Physics",
  "physics.ins-det": "Instrumentation and Detectors",
  "physics.med-ph": "Medical Physics",
  "physics.optics": "Optics",
  "physics.plasm-ph": "Plasma Physics",
  "physics.pop-ph": "Popular Physics",
  "physics.soc-ph": "Physics and Society",
  "physics.space-ph": "Space Physics",

  "quant-ph": "Quantum Physics",

  "q-bio.BM": "Biomolecules",
  "q-bio.CB": "Cell Behavior",
  "q-bio.GN": "Genomics",
  "q-bio.MN": "Molecular Networks",
  "q-bio.NC": "Neurons and Cognition",
  "q-bio.OT": "Other Quantitative Biology",
  "q-bio.PE": "Populations and Evolution",
  "q-bio.QM": "Quantitative Methods",
  "q-bio.SC": "Subcellular Processes",
  "q-bio.TO": "Tissues and Organs",

  "q-fin.CP": "Computational Finance",
  "q-fin.EC": "Economics",
  "q-fin.GN": "General Finance",
  "q-fin.MF": "Mathematical Finance",
  "q-fin.PM": "Portfolio Management",
  "q-fin.PR": "Pricing of Securities",
  "q-fin.RM": "Risk Management",
  "q-fin.ST": "Statistical Finance",
  "q-fin.TR": "Trading and Market Microstructure",

  "stat.AP": "Applications",
  "stat.CO": "Computation",
  "stat.ME": "Methodology",
  "stat.ML": "Machine Learning",
  "stat.OT": "Other Statistics",
  "stat.TH": "Statistics Theory"
};

export const CATEGORY_MAPPINGS: Record<string, string> = {
  // Computer Science
  'cs': 'Computer Science',
  'cs.AI': 'Computer Science',
  'cs.AR': 'Computer Science',
  'cs.CC': 'Computer Science',
  'cs.CE': 'Computer Science',
  'cs.CG': 'Computer Science',
  'cs.CL': 'Computer Science',
  'cs.CR': 'Computer Science',
  'cs.CV': 'Computer Science',
  'cs.CY': 'Computer Science',
  'cs.DB': 'Computer Science',
  'cs.DC': 'Computer Science',
  'cs.DL': 'Computer Science',
  'cs.DM': 'Computer Science',
  'cs.DS': 'Computer Science',
  'cs.ET': 'Computer Science',
  'cs.FL': 'Computer Science',
  'cs.GL': 'Computer Science',
  'cs.GR': 'Computer Science',
  'cs.GT': 'Computer Science',
  'cs.HC': 'Computer Science',
  'cs.IR': 'Computer Science',
  'cs.IT': 'Computer Science',
  'cs.LG': 'Computer Science',
  'cs.LO': 'Computer Science',
  'cs.MA': 'Computer Science',
  'cs.MM': 'Computer Science',
  'cs.MS': 'Computer Science',
  'cs.NA': 'Computer Science',
  'cs.NE': 'Computer Science',
  'cs.NI': 'Computer Science',
  'cs.OH': 'Computer Science',
  'cs.OS': 'Computer Science',
  'cs.PF': 'Computer Science',
  'cs.PL': 'Computer Science',
  'cs.RO': 'Computer Science',
  'cs.SC': 'Computer Science',
  'cs.SD': 'Computer Science',
  'cs.SE': 'Computer Science',
  'cs.SI': 'Computer Science',
  'cs.SY': 'Computer Science',

  // Mathematics
  'math': 'Mathematics',
  'math.AC': 'Mathematics',
  'math.AG': 'Mathematics',
  'math.AP': 'Mathematics',
  'math.AT': 'Mathematics',
  'math.CA': 'Mathematics',
  'math.CO': 'Mathematics',
  'math.CT': 'Mathematics',
  'math.CV': 'Mathematics',
  'math.DG': 'Mathematics',
  'math.DS': 'Mathematics',
  'math.FA': 'Mathematics',
  'math.GM': 'Mathematics',
  'math.GN': 'Mathematics',
  'math.GR': 'Mathematics',
  'math.GT': 'Mathematics',
  'math.HO': 'Mathematics',
  'math.IT': 'Mathematics',
  'math.KT': 'Mathematics',
  'math.LO': 'Mathematics',
  'math.MG': 'Mathematics',
  'math.MP': 'Mathematics',
  'math.NA': 'Mathematics',
  'math.NT': 'Mathematics',
  'math.OA': 'Mathematics',
  'math.OC': 'Mathematics',
  'math.PR': 'Mathematics',
  'math.QA': 'Mathematics',
  'math.RA': 'Mathematics',
  'math.RT': 'Mathematics',
  'math.SG': 'Mathematics',
  'math.SP': 'Mathematics',
  'math.ST': 'Mathematics',

  // Physics
  'physics': 'Physics',
  'physics.acc-ph': 'Physics',
  'physics.ao-ph': 'Physics',
  'physics.app-ph': 'Physics',
  'physics.atm-clus': 'Physics',
  'physics.atom-ph': 'Physics',
  'physics.bio-ph': 'Physics',
  'physics.chem-ph': 'Physics',
  'physics.class-ph': 'Physics',
  'physics.comp-ph': 'Physics',
  'physics.data-an': 'Physics',
  'physics.ed-ph': 'Physics',
  'physics.flu-dyn': 'Physics',
  'physics.gen-ph': 'Physics',
  'physics.geo-ph': 'Physics',
  'physics.hist-ph': 'Physics',
  'physics.ins-det': 'Physics',
  'physics.med-ph': 'Physics',
  'physics.optics': 'Physics',
  'physics.plasm-ph': 'Physics',
  'physics.pop-ph': 'Physics',
  'physics.soc-ph': 'Physics',
  'physics.space-ph': 'Physics',
  'astro-ph': 'Physics',
  'astro-ph.CO': 'Physics',
  'astro-ph.EP': 'Physics',
  'astro-ph.GA': 'Physics',
  'astro-ph.HE': 'Physics',
  'astro-ph.IM': 'Physics',
  'astro-ph.SR': 'Physics',
  'cond-mat': 'Physics',
  'cond-mat.dis-nn': 'Physics',
  'cond-mat.mes-hall': 'Physics',
  'cond-mat.mtrl-sci': 'Physics',
  'cond-mat.other': 'Physics',
  'cond-mat.quant-gas': 'Physics',
  'cond-mat.soft': 'Physics',
  'cond-mat.stat-mech': 'Physics',
  'cond-mat.str-el': 'Physics',
  'cond-mat.supr-con': 'Physics',
  'gr-qc': 'Physics',
  'hep-ex': 'Physics',
  'hep-lat': 'Physics',
  'hep-ph': 'Physics',
  'hep-th': 'Physics',
  'math-ph': 'Physics',
  'nlin': 'Physics',
  'nlin.AO': 'Physics',
  'nlin.CD': 'Physics',
  'nlin.CG': 'Physics',
  'nlin.PS': 'Physics',
  'nlin.SI': 'Physics',
  'nucl-ex': 'Physics',
  'nucl-th': 'Physics',
  'quant-ph': 'Physics',

  // Quantitative Biology
  'q-bio': 'Quantitative Biology',
  'q-bio.BM': 'Quantitative Biology',
  'q-bio.CB': 'Quantitative Biology',
  'q-bio.GN': 'Quantitative Biology',
  'q-bio.MN': 'Quantitative Biology',
  'q-bio.NC': 'Quantitative Biology',
  'q-bio.OT': 'Quantitative Biology',
  'q-bio.PE': 'Quantitative Biology',
  'q-bio.QM': 'Quantitative Biology',
  'q-bio.SC': 'Quantitative Biology',
  'q-bio.TO': 'Quantitative Biology',

  // Quantitative Finance
  'q-fin': 'Quantitative Finance',
  'q-fin.CP': 'Quantitative Finance',
  'q-fin.EC': 'Quantitative Finance',
  'q-fin.GN': 'Quantitative Finance',
  'q-fin.MF': 'Quantitative Finance',
  'q-fin.PM': 'Quantitative Finance',
  'q-fin.PR': 'Quantitative Finance',
  'q-fin.RM': 'Quantitative Finance',
  'q-fin.ST': 'Quantitative Finance',
  'q-fin.TR': 'Quantitative Finance',

  // Statistics
  'stat': 'Statistics',
  'stat.AP': 'Statistics',
  'stat.CO': 'Statistics',
  'stat.ME': 'Statistics',
  'stat.ML': 'Statistics',
  'stat.OT': 'Statistics',
  'stat.TH': 'Statistics',

  // Economics
  'econ': 'Economics',
  'econ.EM': 'Economics',
  'econ.GN': 'Economics',
  'econ.TH': 'Economics',

  // Electrical Engineering and Systems Science
  'eess': 'Electrical Engineering',
  'eess.AS': 'Electrical Engineering',
  'eess.IV': 'Electrical Engineering',
  'eess.SP': 'Electrical Engineering',
  'eess.SY': 'Electrical Engineering',

  // Additional common categories that might appear
  'Machine Learning': 'Computer Science',
  'Artificial Intelligence': 'Computer Science',
  'Data Science': 'Computer Science',
  'Bioinformatics': 'Quantitative Biology',
  'Computational Biology': 'Quantitative Biology',
  'Applied Mathematics': 'Mathematics',
  'Pure Mathematics': 'Mathematics',
  'Theoretical Physics': 'Physics',
  'Experimental Physics': 'Physics',
  'Astrophysics': 'Physics',
  'Condensed Matter': 'Physics',
  'High Energy Physics': 'Physics',
  'Nuclear Physics': 'Physics',
  'Quantum Physics': 'Physics',
  'Mathematical Physics': 'Physics',
};

/**
 * Maps a specific category to its broader parent category
 * @param category The specific category to map
 * @returns The broader parent category
 */
export const mapToBroadCategory = (category: string): string => {
  // First check direct mappings
  if (CATEGORY_MAPPINGS[category]) {
    return CATEGORY_MAPPINGS[category];
  }

  // If no direct mapping, try to extract the main category from arXiv format
  const lowerCategory = category.toLowerCase();
  
  if (lowerCategory.startsWith('cs.') || lowerCategory === 'cs') {
    return 'Computer Science';
  }
  if (lowerCategory.startsWith('math.') || lowerCategory === 'math') {
    return 'Mathematics';
  }
  if (lowerCategory.startsWith('physics.') || lowerCategory === 'physics') {
    return 'Physics';
  }
  if (lowerCategory.startsWith('astro-ph') || lowerCategory.startsWith('cond-mat') || 
      lowerCategory.startsWith('hep-') || lowerCategory.startsWith('nucl-') || 
      lowerCategory === 'gr-qc' || lowerCategory === 'quant-ph' || 
      lowerCategory === 'math-ph' || lowerCategory.startsWith('nlin')) {
    return 'Physics';
  }
  if (lowerCategory.startsWith('q-bio') || lowerCategory === 'q-bio') {
    return 'Quantitative Biology';
  }
  if (lowerCategory.startsWith('q-fin') || lowerCategory === 'q-fin') {
    return 'Quantitative Finance';
  }
  if (lowerCategory.startsWith('stat.') || lowerCategory === 'stat') {
    return 'Statistics';
  }
  if (lowerCategory.startsWith('econ.') || lowerCategory === 'econ') {
    return 'Economics';
  }
  if (lowerCategory.startsWith('eess.') || lowerCategory === 'eess') {
    return 'Electrical Engineering';
  }

  // If no mapping found, return the original category
  return category;
};

/**
 * Gets the human-readable name for an arXiv category
 * @param category The arXiv category code (e.g., 'cs.LG')
 * @returns The human-readable category name (e.g., 'Machine Learning')
 */
export const getArxivCategoryName = (category: string): string => {
  return ARXIV_CATEGORY_NAMES[category] || category;
};

/**
 * Groups categories by their broader parent categories
 * @param categories Object with category names as keys and counts as values
 * @returns Object with broad categories as keys and summed counts as values
 */
export const groupCategoriesByBroad = (categories: Record<string, number>): Record<string, number> => {
  const grouped: Record<string, number> = {};
  
  Object.entries(categories).forEach(([category, count]) => {
    const broadCategory = mapToBroadCategory(category);
    grouped[broadCategory] = (grouped[broadCategory] || 0) + count;
  });
  
  return grouped;
};
